<template>
  <div class="formSubmit" align="center">
    <div
      style="
        padding-top: 92px;
        font-family: 'Roboto Serif', serif;
        font-weight: 800;
        font-size: 50px;
        line-height: 59px;
      "
    >
      Ready to start your practice?
    </div>
    <div
      style="
        padding-top: 18px;
        font-family: 'Roboto';
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
      "
    >
      Book a demo with an EHR Specialist today!
    </div>
    <div style="padding-top: 100px" align="left">
      <el-row :gutter="60">
        <el-col :span="6" :offset="6"> First Name </el-col>
        <el-col :span="6"> Last Name </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="6" :offset="6">
          <el-input v-model="firstName"></el-input>
        </el-col>
        <el-col :span="6">
          <el-input v-model="lastName"></el-input>
        </el-col>
      </el-row>
    </div>
    <div style="padding-top: 60px" align="left">
      <el-row :gutter="60">
        <el-col :span="6" :offset="6"> Email Address </el-col>
        <el-col :span="6"> Contact Number </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="6" :offset="6">
          <el-input v-model="email"></el-input>
        </el-col>
        <el-col :span="6">
          <el-input v-model="number"></el-input>
        </el-col>
      </el-row>
    </div>
    <div style="padding-top: 60px" align="left">
      <el-row :gutter="60">
        <el-col :span="12" :offset="6"> How did you hear about us? </el-col>
      </el-row>
      <el-row :gutter="60">
        <el-col :span="12" :offset="6">
          <el-input v-model="source"></el-input>
        </el-col>
      </el-row>
    </div>
    <div style="padding-top: 60px; padding-bottom: 100px">
      <el-button style="background-color: #ffffff; color: #3e6161" @click="request()">
        Request a Demo Now
        <i class="el-icon-right el-icon--right" style="font-size: 16px"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import {
  SEND_REQUEST
} from '@/graphQL/mutations'

export default {
  data() {
    return {
      screenWidth: window.innerWidth,
      webPage: true,
      firstName: undefined,
      lastName: undefined,
      email: undefined,
      number: undefined,
      source: undefined
    };
  },
  methods: {
    async request(){
      if (!this.firstName || !this.lastName || !this.email || !this.number || !this.source){
        this.$message.error({
          message: 'Please fill all blank inputs'
        })
        return
      }
      try {
        const mutateObj = {
          input: {
            first_name: this.firstName,
            last_name: this.lastName,
            phone: this.number,
            email: this.email,
            source: this.source
          }
        }
        const result = await this.$apollo.mutate({
          mutation: SEND_REQUEST,
          variables: mutateObj,
          
        })
        console.log('111111', result)
      } catch {
        this.$message.error({
          message: 'Please fill all blank inputs'
        })
      }
      this.$message.success({
        message: 'Request sent successfully'
      })
    }
  }
} 
</script>

<style>

.formSubmit {
  height: 824px;
  width: 1440px;
  color: #ffffff;
  background-color: #3e6161;
}
</style>
